import { ReactNode, useEffect } from 'react';
import resume from "./Images/fw18_0989-Ganesh-Kumar-resume.pdf"
import gk from "./Images/gk.png"
import { Menu,MenuButton,MenuItem ,MenuList,IconButton} from "@chakra-ui/react"
import { HamburgerIcon } from "@chakra-ui/icons"
import ganesh2 from "./Images/ganesh2.jpg"
import { SunIcon,MoonIcon } from '@chakra-ui/icons';
import './App.css';
import { useState } from 'react';
import { Box,Text,Stack,Image,Spacer, Button, Flex, Link,useColorModeValue,useDisclosure,
  useColorMode, Heading,Wrap, HStack } from '@chakra-ui/react';
import { Projects } from './Components/Projects';
import { About } from './Components/About';
import {Skill }  from './Components/Skills';
import { Contact } from './Components/Contact';
import { FaDownload, FaHeart,FaSmile } from 'react-icons/fa';
import { useRef } from 'react';
function App() {
  const { colorMode, toggleColorMode } = useColorMode();
  console.log(colorMode)
  const { isOpen, onOpen, onClose } = useDisclosure();
  
  const aboutRef = useRef(null);
  const projectRef = useRef(null);
  const contactRef = useRef(null);
  const skillsRef = useRef(null);

  function refFunc(a){

    a.current.scrollIntoView({ behavior : "smooth" });
    console.log("project",a.current)
  } 

  var arr = [
    {
      img : "asana.com.jpg",title : "Asana Onboarding Process",about : "Asana is a Saas platform that helps you manage your project and the team working on the project.", techStack : ["HTML","CSS","Reveal.js"], areas : ["Content searching for presentation","Made overall design and layout of the presentation"],netlifyLink:"https://charming-conkies-139cf5.netlify.app/",gitLink:"https://github.com/shivanithakur36/Asana_Project"
    }, {
      img : "kfcscreenshot-2.jpg",title : "Clone of KFC",about : "The KFC website is an online food ordering and delivery platform from your nearby Restaurants.", techStack : ["html","css","javascript"], areas:["Build a Cart Page and Apply coupon functionalities.","Developed the Navbar and Home Page."], netlifyLink:"https://ganesh-onlinekfc.netlify.app/",gitLink:"https://github.com/anuragg0107/busy-channel-5933"
    }
  ]

  const skillsArr1 = [
    {img :"https://www.freepnglogos.com/uploads/linux-png/linux-logo-logo-brands-for-0.png", name:"Linux"},
    { img:"https://bashlogo.com/img/symbol/png/full_colored_dark.png", name : "Shell Scripting" },
    { img:"https://www.freepnglogos.com/uploads/logo-mysql-png/logo-mysql-mysql-and-moodle-elearningworld-5.png", name : "MySQL" },{img:"https://w7.pngwing.com/pngs/899/691/png-transparent-computer-network-global-network-global-network-material-text-globe-logo.png",name:"Networking"},
    { img : "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg", name : "HTML"  }, {
      img : "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg", name : "CSS"
    }, {
      img : "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" ,name : "JavaScript"
    }, {
      img : "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg" ,name : "BootStrap"
    }, {
      img :"https://chiranjeev-thapliyal.vercel.app/svg/reactjs.svg" , name : "React"
    } , {
      img :"https://www.svgrepo.com/show/303557/redux-logo.svg" , name : "Redux"
    }, {
      img : "https://avatars.githubusercontent.com/u/54212428?s=280&v=4" , name : "Chakra UI"
    }, {
      img : "https://ankurm.com/wp-content/uploads/2013/06/Git-Logo.jpg" , name : "Git"
    }
  ]
  
  const skillsArr2 =[ {img : "https://st3.depositphotos.com/13360910/32337/v/600/depositphotos_323370184-stock-illustration-troubleshoot-web-element-icon-vector.jpg",name:"Troubleshoot"},{img : "https://png.pngtree.com/png-vector/20220518/ourmid/pngtree-employing-active-listening-blue-gradient-concept-icon-png-image_4675869.png", name:"Active Listening"}, {img :"https://png.pngtree.com/png-vector/20220520/ourmid/pngtree-problem-solving-concept-question-advice-png-image_4686512.png", name:"Problem Solving"},{img : "https://cdn.w600.comps.canstockphoto.com/communication-vector-line-icon-linear-clipart-vector_csp69253253.jpg", name : "Communication"}]

  const skillsArr3 = [
    { img:"https://png.pngtree.com/png-vector/20220628/ourmid/pngtree-leadership-logo-puzzle-people-vector-png-image_5530416.png", name : "Team Work" },
    { img:"https://thumbs.dreamstime.com/b/patience-icon-trendy-patience-logo-concept-white-background-patience-icon-trendy-patience-logo-concept-white-background-131190341.jpg", name : "Patience" },
    { img : "https://png.pngtree.com/png-vector/20190615/ourmid/pngtree-teambusinessceoexecutiveleaderleadershipperson--flat-png-image_1486402.jpg", name : "LeaderShip"  }]

  function downloadResume() {
    const link = document.createElement('a');
    link.href = resume;
    link.download = 'fw18_0989-Ganesh-Kumar-resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  

  return (
    <Box className="App" bg={useColorModeValue("#ECF0F1","black")} color={useColorModeValue("black","white")} >   
     <Box pb={"50px"} >
     <Box>

        <Flex  h={["70px","80px","90px"]} w={{base:"100%",sm:"100%",md:"100%",lg:"80%"}}
         background={"rgba(42,43,56,.6)"} paddingX={{sm:"30px",md:"40px",lg:"50px"}} border={{base:"none",sm:"none",md:"none",lg:".25rem solid #2a2b37"}} borderBottom=".25rem solid #2a2b37" backdropFilter={"blur(20px)"} borderRadius={{base:"0",sm:"0",md:"0",lg:"40px"}} zIndex={"5"} pos="fixed" mt={{base:"0",sm:"0",md:"0",lg:"30px"}} left={{base:"0",sm:"0",md:"0",lg:"10.5%"}} alignItems="center">

        <Box alignItems="center"  >
          <Image src={gk} w={["60px","70px","95px"]} h={["55px","60px","65px"]} borderRadius="50%" />
       </Box>
   
       <Box ml="5%" alignItems="center" textAlign="left" w={["none","none","none","40%"]} >
        <Box fontSize={{base:"17px",sm:"19px",md:"sm",lg:"lg"}} fontWeight={"700"} >
             <Text>GANESH KUMAR</Text>
          </Box>
             <Text fontSize={"md"} fontWeight="600" color={'blue.500'}  > PortFolio</Text>
          </Box>
          
          <Spacer />

          <Box display={{base:"flex",sm:"flex",md:"none"}} >
          <Menu  >
    <MenuButton as={IconButton} colorScheme="yellow" icon={<HamburgerIcon/> } >
    </MenuButton>
    <MenuList backgroundColor={useColorModeValue("black","white")} color={useColorModeValue("white","black")} >
        <MenuItem backgroundColor={useColorModeValue("black","white")} fw="700"  _hover={{color:"blue.600",fw:"700",textDecoration:"underline",cursor:"pointer"}}  onClick={() => {refFunc(aboutRef)}} >About</MenuItem>
        <MenuItem  fw="700"  backgroundColor={useColorModeValue("black","white")}  _hover={{color:"blue.600",fw:"700",textDecoration:"underline",cursor:"pointer"}}  onClick={() => {refFunc(projectRef)}} >Projects </MenuItem>
  
        <MenuItem  backgroundColor={useColorModeValue("black","white")} fw="700"  _hover={{color:"blue.600",fw:"700",textDecoration:"underline",cursor:"pointer"}}  onClick={() => {refFunc(skillsRef)}} >Skills</MenuItem>

        <MenuItem  backgroundColor={useColorModeValue("black","white")} fw="700"  _hover={{color:"blue.600",fw:"700",textDecoration:"underline",cursor:"pointer"}}  onClick={() => {refFunc(contactRef)}} >Contact Me</MenuItem>
        
        <MenuItem  backgroundColor={useColorModeValue("black","white")} fw="700"  _hover={{color:"blue.600",fw:"700",textDecoration:"underline",cursor:"pointer"}} >
        <Link  target={"_blank"}  href="https://drive.google.com/file/d/1pbwYIoDqE60EZKBRg27Wx6aGSBZdHAAE/view?usp=share_link" isExternal ><Button backgroundColor={useColorModeValue("black","white")} m="0px"   _hover={{color:"blue.600"}} rightIcon={<FaDownload />} onClick={() => downloadResume()} >Resume</Button></Link></MenuItem>
 
        <MenuItem  backgroundColor={useColorModeValue("black","white")} fw="700"  _hover={{color:"blue.600",fw:"700",textDecoration:"underline",cursor:"pointer"}} >
             <Button backgroundColor={useColorModeValue("black","white")} onClick={toggleColorMode}>
                {colorMode === 'dark' ? <MoonIcon /> : <SunIcon />}
              </Button>
             </MenuItem>
    </MenuList>
  </Menu>
          </Box>
          
          <Flex  alignItems={'center'} display={{base:"none",sm:"none",md:"flex"}}  w={{base:"0",sm:"0",md:"55%",lg:"90%"}} fontSize={{base:"17px",sm:"19px",md:"sm",lg:"md"}} justifyContent="space-between" >
           
              <Box fw="700"  _hover={{color:'blue.500',fontWeight:"700",textDecoration:"underline",cursor:"pointer"}}
               onClick={() => {refFunc(aboutRef)}} >
                About
              </Box>
              <Spacer/>
              <Box  onClick={() => {refFunc(projectRef)}}  _hover={{color:'blue.500',fontWeight:"700",textDecoration:"underline",cursor:"pointer"}} >
                projects
              </Box>
              <Spacer />
              <Box   _hover={{color:'blue.500',fontWeight:"700",textDecoration:"underline",cursor:"pointer"}} 
               onClick={() => {refFunc(skillsRef)}} >
                Skills
              </Box>
              <Spacer/>
              <Box   _hover={{color:'blue.500',fontWeight:"700",textDecoration:"underline",cursor:"pointer"}} 
               onClick={() => {refFunc(contactRef)}} >
                Contact me
              </Box>
              <Spacer />
              <Box   _hover={{color:'blue.500',fontWeight:"700",textDecoration:"underline",cursor:"pointer"}} 
               >
                 <Link  target={"_blank"}  href="https://drive.google.com/file/d/1pbwYIoDqE60EZKBRg27Wx6aGSBZdHAAE/view?usp=share_link" isExternal ><Button m="0px"  backgroundColor={"none"} rightIcon={<FaDownload />} onClick={() => downloadResume()} >Resume</Button></Link>
              </Box>
              <Spacer />
             <Box>
             <Button bg={"none"}  _hover={"none"} _focus={"none"} onClick={()=>{toggleColorMode()}}>
                {colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
              </Button>
             </Box>
          </Flex>
        </Flex>
      </Box>
     </Box>
     
        <Box className='home' w={{sm:"90%",md:"70%",lg:"60%"}} m="auto" pt={["20px","30px","60px"]} >
             
             <Stack w={"100%"} direction={{base:"column",sm:"column",md:"row",lg:"row"}} fontWeight="700" mt="80px" >
              <Box mt={{base:"-50px",sm:"",md:"40px",lg:"50px"}} w={["70%","70%","50%","100%"]} m={["auto","none"]} >
              <Text fontSize={["13px","lg"]} align="left" >Hi, this is</Text>
                <Text align={"left"} color='blue.500' fontSize={{base:"2xl",sm:"3xl",md:"4xl",lg:"5xl"}} m={["0px","0px","-10px"]} >GANESH KUMAR</Text>
                <Text align="left" fontSize={["12px","lg"]} > Tech Support Engineer  </Text>

               <Flex w={["100%","100%","100%","70%"]} m={"auto"} mt={["20px","30px","40px"]}>
                <Link color='blue.500' h="40px" w="40%" href="mailto:kganesh011995@gmail.com" isExternal ><Button  h="40px" w="100%"  background={"rgba(42,43,56,.2)"} paddingX={{sm:"30px",md:"40px",lg:"50px"}} border={{base:"none",sm:"none",md:"none",lg:".15rem solid #2a2b37"}} borderBottom=".25rem solid #2a2b37"  _hover={{background:"rgba(42,43,56,.9)"}} backdropFilter={"blur(20px)"} >Get In Touch</Button></Link>
               <Spacer/>
               <Link color='blue.500' h="40px" target={"_blank"} w="40%"  href="https://drive.google.com/file/d/1pbwYIoDqE60EZKBRg27Wx6aGSBZdHAAE/view?usp=share_link" isExternal >
                <Button h="40px" w="100%" background={"rgba(42,43,56,.2)"} paddingX={{sm:"30px",md:"40px",lg:"50px"}} border={{base:"none",sm:"none",md:"none",lg:".15rem solid #2a2b37"}}  _hover={{background:"rgba(42,43,56,.9)"}} borderBottom=".25rem solid #2a2b37" textDecorationColor={'blue.500'} backdropFilter={"blur(20px)"} onClick={downloadResume} >Resume</Button></Link>
                </Flex>
              </Box>
                      <Spacer/>
             
                     <Box w={["70%","70%","60%","60%"]} margin={["auto"]} pl={["20%","20%","0px","0px"]} > 
                <Image borderRadius={"100%"} w="120%" h={"370px"} mt={["","","",""]} src={ganesh2} />
              </Box>
             </Stack>

        </Box>

        <Box className='about' mt={"100px"} ref={aboutRef} >
        <Heading marginLeft={{base:"20px",sm:"30px",md:"15%"}} mb={{base:"10px",sm:"15px",md:"30px",lg:"50px"}} size='lg' textAlign={"left"} color="blue.500" >About Me:</Heading>
            <About/>
        </Box>

        <Box className='skills' mt={"100px"} ref={skillsRef} >
        <Heading marginLeft={{base:"20px",sm:"30px",md:"15%"}} mb={{base:"10px",sm:"15px",md:"30px",lg:"50px"}} size='lg' textAlign={"left"} color="blue.500" >Skills:</Heading>
        <Box borderWidth="1px"
    borderRadius="lg"
    w={{ sm: '100%', md: '750px', lg:"70%" }} boxShadow={'2xl'}
    padding={10} m="auto"  bg={useColorModeValue('white','gray.900')} >
      <Heading textAlign="center" textDecoration={"underline"} mb={{base:"10px",sm:"15px",md:"30px",lg:"50px"}} size='md' color="blue.500" >Technical Skills</Heading>
           <Wrap
     spacing={"35px"} >
      
           { skillsArr1.map((el) => {
              return <Skill {...el} key={el.name} />
           }) }
           </Wrap>

           <Heading textAlign="center" textDecoration={"underline"} marginY={{base:"10px",sm:"15px",md:"30px",lg:"50px"}} size='md' color="blue.500" >Customer Service Skills</Heading>
           <Wrap
     spacing={"35px"} >
      
           { skillsArr2.map((el) => {
              return <Skill {...el} key={el.name} />
           }) }
           </Wrap>

           <Heading textAlign="center" textDecoration={"underline"} marginY={{base:"10px",sm:"15px",md:"30px",lg:"50px"}} size='md' color="blue.500" >Soft Skills</Heading>
           <Wrap
     spacing={"35px"} >
      
           { skillsArr3.map((el) => {
              return <Skill {...el} key={el.name} />
           }) }
           </Wrap>

           </Box>
        </Box>

        <Box className='projects' mt={"100px"} ref={projectRef} >
        <Heading marginLeft={{base:"20px",sm:"30px",md:"15%"}} mb={{base:"10px",sm:"15px",md:"30px",lg:"50px"}} size='lg' textAlign={"left"} color="blue.500" >Projects:</Heading>
             
           {arr.map((el)=>{
            return <Projects {...el} />
           })}
        </Box>

        <Box className='contact' mt={"100px"} pb="100px" ref={contactRef} >
        <Heading marginLeft={{base:"20px",sm:"30px",md:"15%"}} my="50px" size='lg' textAlign={"left"} color="blue.500" >Contact me:</Heading>

        <Contact />

        </Box>
       <HStack marginLeft={"75%"} color={"skyblue"} pb={"100px"} >
       <FaHeart color='red' />  <Text>Made by Ganesh  </Text><FaSmile color='white' />
       </HStack>
    </Box>
  );
}

export default App;
